module.exports = __webpack_public_path__ + "static/img/yxMerchant.f426cde2.png";